import React, { memo } from 'react';
import { StyleSheet, TouchableOpacity, View } from 'react-native';
import { CommonProperties, Color, CommonStyles } from '../../styles';
import { formatCurrency } from '../../utils/currency.utils';
import BaseText from '../BaseText';
import ListControl from './ListControl';

const SegmentedItem = ({ selected, label, price, disable, ...rest }) => {
  return (
    <TouchableOpacity
      style={[styles.hotelItemSegmented, selected && styles.selected, disable && styles.disabled]}
      {...rest}
    >
      <View style={CommonStyles.centerAlignment}>
        <BaseText style={[styles.hotelTextUp, selected && styles.primaryText]}>{label}</BaseText>
        <BaseText style={[CommonStyles.h1, selected ? styles.primaryText : styles.secondText]}>
          {price}
        </BaseText>
      </View>
    </TouchableOpacity>
  );
};

const SegmentedControl = memo(({ items, selected, currency, currencyCulture, onChange }) => {
  return (
    <ListControl
      items={items}
      style={styles.segmentedHotel}
      renderItem={(item) => (
        <SegmentedItem
          selected={item.value === selected}
          label={item.label}
          price={formatCurrency(item.price, currency, currencyCulture)}
          disable={item.disable}
          onPress={() => onChange(item.value)}
        />
      )}
    />
  );
});

const styles = StyleSheet.create({
  segmentedHotel: {
    ...CommonProperties.borderRadius,
    overflow: 'hidden',
  },
  hotelItemSegmented: {
    flex: 1,
    ...CommonProperties.py2,
  },
  hotelTextUp: {
    marginBottom: -6,
    color: Color.primary,
    ...CommonProperties.small,
  },
  primaryText: {
    color: 'white',
  },
  secondText: {
    color: Color.primary,
  },
  disabled: {
    opacity: 0.5,
  },
  selected: {
    backgroundColor: Color.primary,
  },
});

export default SegmentedControl;
